export default __webpack_public_path__ + "static/media/ic_flp_custom.11dd75db.svg";